import { Component, OnInit } from '@angular/core';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { GeneratedPeriodicReport } from 'src/app/models/turns-models/periodic-report.model';
import { PeriodicReportsTurnsService } from 'src/app/services/turns-services/periodic-reports-turns-service/periodic-reports-turns.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-turns-reports-periodic-dashboard',
  templateUrl: './turns-reports-periodic-dashboard.component.html',
  styleUrls: ['./turns-reports-periodic-dashboard.component.scss']
})
export class TurnsReportsPeriodicDashboardComponent implements OnInit {
  reports: GeneratedPeriodicReport[] = [];
  loading = true;
  filterText = '';

  constructor(private service: PeriodicReportsTurnsService,
              private breadcrumb: HeaderBreadcrumbService,
              private snack: SnackBarService,
              private translate: TranslateService) { }

  ngOnInit() {
    this.breadcrumb.setRoutes(new Breadcrumb('fas fa-file-pdf', 'turns-periodic.title', '/turns/reports', [
      new BRoute('turns-page.turns', '/turns'),
      new BRoute('turns-page.turns reports', '/turns/reports'),
      new BRoute('turns-periodic.title')
    ]));
    this.reload();
  }

  reload() {
    this.loading = true;
    this.service.generated().subscribe(
      reports => {
        this.reports = (reports || []).slice().sort((a, b) =>
          (b.generatedDate || '').localeCompare(a.generatedDate || ''));
        this.loading = false;
      },
      error => { this.loading = false; this.snack.open(error.error && error.error.message || error.message, 'error'); }
    );
  }

  centers(report: GeneratedPeriodicReport) {
    return (report.centers || []).map(center => center.name).join(', ');
  }

  get filteredReports() {
    const query = this.filterText.trim().toLowerCase();
    return query ? this.reports.filter(report =>
      (report.configName || '').toLowerCase().indexOf(query) !== -1 ||
      this.centers(report).toLowerCase().indexOf(query) !== -1) : this.reports;
  }

  statusLabel(status: string) {
    if (!status) { return '-'; }
    const key = 'turns-periodic.status.' + status;
    const translated = this.translate.instant(key);
    return translated === key ? status : translated;
  }
}
